export { default } from './part-first-screen-banner';
